import { MultiSelectComparisonOperator } from '../enums/MultiSelectComparisonOperator';

export class MultiSelectDescriptor
{
    public constructor(op: MultiSelectComparisonOperator, value: string[])
    {
        this.operator = op;
        this.value = value;
    }

    public value!: string[];

    public operator!: MultiSelectComparisonOperator;
}